<div #contentDiv class="max-w-lg mx-auto flex flex-col pt-20 min-h-[calc(100vh)]">
  <div class="flex-1 bg-theme-surface rounded-t-3xl min-h-full p-4 text-theme-text">
    <!-- Bakåt -->
    <div class="flex items-center space-x-4">
      <app-circle-button [icon]="'fa-chevron-left'" size="12" type="solid" fontSize="xl" (onClick)="back()"></app-circle-button>
    </div>

    <div class="flex flex-col bg-theme-surface rounded-t-3xl px-8 pt-16 justify-center item items-center">
      <!-- Ikon -->
      <i class="fas fa-circle-exclamation text-theme-text text-9xl"></i>

      <!-- Rubrik -->
      <h2 class="text-2xl font-bold text-theme-text pt-4">{{translate.getString('Något gick snett')}}</h2>

      <!-- Felmeddelande -->
      <p class="text-lg text-theme-text pt-4 font-semibold">{{translate.getString('Betalningen gick inte igenom')}}</p>

      <!-- Knapppanel -->
      <div class="env-panel w-full max-w-md p-4 bg-primary rounded pt-4">
        <app-border-icon-button icon="fa-repeat" [text]="translate.getString('Försök igen')" (onClick)="retryPayment()"></app-border-icon-button>
      </div>
    </div>
  </div>
</div>

